import { render } from "./ResultsComponent.vue?vue&type=template&id=90cdb64e&scoped=true"
import script from "./ResultsComponent.vue?vue&type=script&lang=js"
export * from "./ResultsComponent.vue?vue&type=script&lang=js"

import "./ResultsComponent.vue?vue&type=style&index=0&id=90cdb64e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\chris\\Documents\\quizmegpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90cdb64e"]])

export default __exports__